import { myAccountViewStyles as styles } from "@insite/content-library/Widgets/MyAccount/MyAccountView";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.quickLinksGridItem = {
    ...styles.quickLinksGridItem,
    css: css`
        ${styles.quickLinksGridItem?.css}
        margin: 24px 0 0 !important;

        ${mediaQueriesBP.minMD} {
            margin: 40px 0 0 !important;
        }
    `,
};

styles.mainSectionGridItem = {
    ...styles.mainSectionGridItem,
    css: css`
        ${styles.mainSectionGridItem?.css}
        margin: 24px 0 0 !important;

        ${mediaQueriesBP.minMD} {
            margin: 40px 0 0 !important;
        }
    `,
};


// Verndale Customization - hide account messages
styles.accountMessagesGridItem = {
    ...styles.accountMessagesGridItem,
    css: css`
        ${styles.accountMessagesGridItem?.css}
        display: none;
    `,
};
